<div class="breadcrumb-area">
    <h1><i class="fa fa-user-group"></i> Afiliados</h1>
    <ol class="breadcrumb">
        <li><span [class.active-url]="url=='convert'" routerLink="/configuration/affiliates/convert"><i class='fa fa-id-card'></i>Convertir clientes a afiliados</span></li>
        <li><span [class.active-url]="url=='admin'" routerLink="/configuration/affiliates/admin"><i class='fa fa-sliders'></i>Administración</span></li>
    </ol>
</div>
<router-outlet></router-outlet>